export default "__VITE_ASSET__f15c8829__"